import { Injectable } from '@angular/core';

const ACCESS_TOKEN_KEY = 'idap.accessToken';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  getToken(): string | null {
    if (!this.canUseSessionStorage()) {
      return null;
    }

    return sessionStorage.getItem(ACCESS_TOKEN_KEY);
  }

  setToken(accessToken: string): void {
    if (!this.canUseSessionStorage()) {
      return;
    }

    sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  }

  clearToken(): void {
    if (!this.canUseSessionStorage()) {
      return;
    }

    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
  }

  private canUseSessionStorage(): boolean {
    return typeof sessionStorage !== 'undefined';
  }
}
